import { render, staticRenderFns } from "./resultDepartDialog.vue?vue&type=template&id=1f8360eb&scoped=true&"
import script from "./resultDepartDialog.vue?vue&type=script&lang=ts&"
export * from "./resultDepartDialog.vue?vue&type=script&lang=ts&"
import style0 from "./resultDepartDialog.vue?vue&type=style&index=0&id=1f8360eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8360eb",
  null
  
)

export default component.exports